export const API_BASE =
    process.env.NODE_ENV === "production"
        ? process.env.REACT_APP_API
        : "http://localhost:4005";

/**
 * dAdmin's origin. It serves the uploaded files this portal renders — employee
 * avatars, banner images, update images — and also the blog media route that
 * blocks_json points at (/api/dolluzcorp/blog/posts/media/...).
 *
 * REACT_APP_EMP_PROFILE_FILE is the existing name for it; kept so no env needs editing.
 */
export const DADMIN_BASE =
    process.env.NODE_ENV === "production"
        ? process.env.REACT_APP_EMP_PROFILE_FILE
        : "http://localhost:4002";

/** Back-compat alias — several components import this name. */
export const EMP_PROFILE_FILE_BASE = DADMIN_BASE;

export const DASSIST_TICKET_FILES_BASE =
    process.env.NODE_ENV === "production"
        ? process.env.REACT_APP_DASSIST_TICKET_FILES
        : "http://localhost:4001";

export const DBUG_TICKET_FILES_BASE =
    process.env.NODE_ENV === "production"
        ? process.env.REACT_APP_DBUG_TICKET_FILES
        : "http://localhost:4004";

export const DTIME_LEAVE_FILES_BASE =
    process.env.NODE_ENV === "production"
        ? process.env.REACT_APP_DTIME_LEAVE_FILES
        : "http://localhost:4003";

/**
 * Resolve a stored file path to a URL on dAdmin.
 * Handles Windows backslashes, absolute API paths, and already-absolute URLs.
 */
export function mediaUrl(filePath) {
    if (!filePath) return "";
    const path = String(filePath).replace(/\\/g, "/");
    if (/^https?:\/\//i.test(path)) return path;
    return `${DADMIN_BASE}${path.startsWith("/") ? "" : "/"}${path}`;
}

// Latches so a burst of parallel 401s triggers exactly one redirect.
let sessionEnded = false;

export async function apiFetch(endpoint, options = {}) {
    const res = await fetch(`${API_BASE}${endpoint}`, {
        credentials: "include",
        ...options,
    });

    // An admin ending this session comes back as 401 SESSION_REVOKED — but ONLY from
    // requireAuth endpoints. Public / optionalAuth endpoints never send it (a revoked
    // viewer just gets the visitor view), which is why the public pages keep working.
    // The login endpoints are exempt so the sign-in page itself is never bounced.
    if (res.status === 401 && !sessionEnded && !endpoint.startsWith("/api/login/")) {
        let message = "";
        try { message = (await res.clone().json())?.message || ""; } catch { /* not JSON */ }
        if (message === "SESSION_REVOKED") {
            sessionEnded = true;
            window.location.replace("/login?revoked=1");
        }
    }
    return res;
}

/**
 * A stable per-browser id, so an anonymous visitor can vote on a banner poll once
 * and we can show them their own answer when they come back.
 *
 * It identifies a browser, not a person — it is not authentication, and the server
 * never grants it any visibility beyond 'general'.
 */
const VISITOR_KEY_STORAGE = "dolluzcorp_visitor_key";

export function getVisitorKey() {
    try {
        let key = localStorage.getItem(VISITOR_KEY_STORAGE);
        if (!key) {
            key =
                typeof crypto !== "undefined" && crypto.randomUUID
                    ? crypto.randomUUID().replace(/-/g, "")
                    : Math.random().toString(36).slice(2) + Date.now().toString(36);
            localStorage.setItem(VISITOR_KEY_STORAGE, key);
        }
        return key;
    } catch {
        // Private mode / storage disabled — voting will just not persist across visits.
        return null;
    }
}
